export const SET_STATS_DATA = 'SET_STATS_DATA'
export const FETCH_STATS_DATA_STATUS = 'FETCH_STATS_DATA_STATUS'

export const SET_CHARTS_DATA = 'SET_CHARTS_DATA'
export const FETCH_CHARTS_DATA_STATUS = 'FETCH_CHARTS_DATA_STATUS'
